import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@hooks/useAuth'
import { ROUTES } from './paths'

export const PublicRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) return <Navigate to={ROUTES.dashboard} replace />
  return <>{children}</>
}
